function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import utils from "../utils";

var GoogleUniversalAnalyticsAdapter = /*#__PURE__*/function () {
  function GoogleUniversalAnalyticsAdapter() {
    _classCallCheck(this, GoogleUniversalAnalyticsAdapter);
  }

  _createClass(GoogleUniversalAnalyticsAdapter, null, [{
    key: "_track",
    value: function _track(category, action, label) {
      utils.log("Google Universal Analytics track", {
        category: category,
        action: action,
        label: label
      });

      if (typeof global.ga !== "function") {
        throw new Error("ga not defined. Please make sure " + "your Universal analytics is set up correctly");
      }

      global.ga("send", "event", category, action, label, {
        nonInteraction: 1
      });
    }
  }, {
    key: "experiment_start",
    value: function experiment_start(experiment, variant) {
      this._track(this.namespace, "".concat(experiment.name, " | ").concat(variant), "Visitors");
    }
  }, {
    key: "goal_complete",
    value: function goal_complete(experiment, variant, goal_name, _props) {
      this._track(this.namespace, "".concat(experiment.name, " | ").concat(variant), goal_name);
    }
  }]);

  return GoogleUniversalAnalyticsAdapter;
}();

_defineProperty(GoogleUniversalAnalyticsAdapter, "namespace", "alephbet");

export default GoogleUniversalAnalyticsAdapter;